<template>
  <div>
    <action-icon
      icon="UploadIcon"
      :tooltip="$t('upload_files')"
      @click="openModalUploadFile()"
    />
    <vs-popup
      :title="$t('upload_files')"
      :active.sync="openModalUpload"
      @close="closeModalUploadFile"
      class="vs-con-loading__container"
    >
      <div>
        <vs-row vs-w="12" class="w-full">
          <qb-upload
            :showUploadButton="false"
            @update-file="handleManualFileUpdate"
            @on-delete="handleManualFileDelete"
            multiple
            :reset="reset"
            :limit="15"
            v-if="openModalUpload"
            accept="application/pdf"
          />
          <vs-button
            color="primary"
            icon-pack="feather"
            icon="icon-upload"
            type="filled"
            class="mr-6 w-full"
            :disabled="files == null || files == []"
            @click="saveFiles"
          >
            {{ $t('save') | capitalize}}
          </vs-button>
        </vs-row>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import ActionIcon from '@/components/ActionIcon.vue'
import QbUpload from '@/components/upload/QbUpload.vue'
import vendor from '@/http/requests/vendor/index.js'

export default {
  components: {
    ActionIcon,
    QbUpload,
  },
  props: {
    request_id: {
      type: String,
      default: '0',
    }
  },
  data: () => ({
    openModalUpload: false,
    files: null,
    reset:false
  }),
  methods: {
    openModalUploadFile() {
      this.openModalUpload = true
    },
    closeModalUploadFile() {
      this.files = new Array()
      this.handleManualFileDelete()
    },

    handleManualFileUpdate: function (e) {
      this.files =  [ ...e ]
    },
    handleManualFileDelete(e) {
      let i = this.files.findIndex((item) => item === e)
      this.files.splice(i, 1)
    },
    saveFiles: function () {
      let form = new FormData()
      this.files.forEach(function (file, i) {
        form.append('files[]', file)
      })
      form.append('requestId', this.request_id)
      vendor
        .repseUpdateFile(form)
        .then((response) => {
          this.files = null
          this.openModalUpload = false

          this.$emit('refresh')
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'File saved.',
          })
        })
        .catch((response) => {
          // console.log(response)
          this.$vs.notify({
            color: 'danger',
            title: 'ERROR',
            text: 'Error saving.',
          })
          this.openModalUpload = false

        })
    },
  },
}
</script>
